/**
 * LogoLoader Component
 * Automatically loads company logo when user is authenticated
 * Reloads on every mount to handle page refreshes and navigation
 */

import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useCompany } from '../../contexts/CompanyContext';

const LogoLoader = () => {
  const { user, isAuthenticated } = useAuth();
  const { loadCompanyData, companyData, forceRefreshLogo } = useCompany();

  useEffect(() => {
    // Load company logo when user is authenticated and not currently loading
    if (isAuthenticated && user && !companyData.loading) {
      // If logo is not loaded or is a blob URL that might have been revoked, reload it
      if (!companyData.loaded || !companyData.logo) {
        loadCompanyData();
      }
    }
  }, [isAuthenticated, user, companyData.loading, companyData.loaded, companyData.logo, loadCompanyData]);

  useEffect(() => {
    // Handle tab visibility changes to refresh logo when user returns to tab
    const handleVisibilityChange = () => {
      if (!document.hidden && isAuthenticated && companyData.logo) {
        // Force refresh logo when tab becomes visible
        forceRefreshLogo();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated, companyData.logo, forceRefreshLogo]);

  // This component doesn't render anything
  return null;
};

export default LogoLoader;